import { createRouter, createWebHashHistory } from "vue-router";
import Layout from "@/layout/index.vue";
import { isRouteAllowedForAccount } from "@/utils/accountPermission";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "首页",
          icon: "House",
        },
      },
      {
        path: "projects",
        name: "Projects",
        component: () => import("@/views/projects/index.vue"),
        meta: {
          title: "我的项目",
          icon: "FolderOpened",
        },
      },
      {
        path: "detail/:id",
        name: "Detail",
        component: () => import("@/views/detail/index.vue"),
        meta: {
          title: "作品详情",
        },
      },
      {
        path: "editor/:id",
        name: "Editor",
        component: () => import("@/views/editor/index.vue"),
        meta: {
          title: "项目编辑",
        },
      },
      {
        path: "myAssets",
        name: "myAssets",
        component: () => import("@/views/myAssets/index.vue"),
        meta: {
          title: "我的资产",
          icon: "CreditCard",
        },
      },
      {
        path: "myAssets/:id",
        name: "MyAssetDetail",
        component: () => import("@/views/myAssets/detail.vue"),
        meta: {
          title: "资产详情",
        },
      },
      {
        path: "invitation",
        name: "invitation",
        component: () => import("@/views/invitation/index.vue"),
        meta: {
          title: "邀请有礼",
          icon: "Present",
        },
      },
      {
        path: "team",
        name: "team",
        component: () => import("@/views/team/index.vue"),
        meta: {
          title: "我的团队",
          icon: "Connection",
        },
      },
      {
        path: "revenue",
        name: "revenue",
        component: () => import("@/views/revenue/index.vue"),
        meta: {
          title: "我的收益",
          icon: "Money",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const whiteList = ["/login", "/", "/home"];

router.beforeEach((to, _, next) => {
  if (whiteList.includes(to.path)) {
    next();
  } else if (!localStorage.getItem("userId")) {
    next({
      path: "/login",
      replace: true,
    });
  } else if (!isRouteAllowedForAccount(to.path)) {
    next({
      path: "/home",
      replace: true,
    });
  } else {
    next();
  }
});

export default router;
